/**
 * @generated SignedSource<<edf9f3b3714a7d78d798db62a3ab72b1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DagvestigationDetails_alert$data = {
  readonly id: any;
  readonly name: string | null | undefined;
  readonly " $fragmentType": "DagvestigationDetails_alert";
};
export type DagvestigationDetails_alert$key = {
  readonly " $data"?: DagvestigationDetails_alert$data;
  readonly " $fragmentSpreads": FragmentRefs<"DagvestigationDetails_alert">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DagvestigationDetails_alert",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    }
  ],
  "type": "GraphQLAlert",
  "abstractKey": null
};

(node as any).hash = "abc27e3284ac050c12788ef30f60a922";

export default node;
